import { useCallback, useEffect, useState } from 'react';

import { useNotifications } from '../NotificationContext';
import type { Notification } from '../types/notification.types';

export const useDangerNotification = () => {
  const { notifications, markAsRead } = useNotifications();
  const [dangerNotification, setDangerNotification] =
    useState<Notification | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Check for danger notifications
  useEffect(() => {
    // Find the first unread danger notification
    const unreadDanger = notifications.find(
      (notification) =>
        notification.type.toLowerCase() === 'error' && !notification.is_read,
    );

    if (unreadDanger && !isDialogOpen) {
      setDangerNotification(unreadDanger);
      setIsDialogOpen(true);
    }
  }, [notifications, isDialogOpen]);

  // Handle closing the dialog
  const handleCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
    // We don't clear the notification here anymore
    // This ensures the user must click "تم القراءة" to close the dialog
  }, []);

  // Handle marking as read
  const handleMarkAsRead = useCallback(
    async (id: string) => {
      await markAsRead(id);
      setIsDialogOpen(false);
      setDangerNotification(null);
    },
    [markAsRead],
  );

  return {
    dangerNotification,
    isDialogOpen,
    handleCloseDialog,
    handleMarkAsRead,
  };
};
